import { getUsedFonts } from "@plt-bet/blocks/site";

const filterFonts = (config: any): void => {
  if (!Array.isArray(config?.settings?.fonts) || config.settings.fonts.length === 0 || !config.blocks) {
    return;
  }

  config.settings.fonts = getUsedFonts(config.settings.fonts, config.blocks);
};

export const parseAppConfig = (rawJson: string | undefined): any => {
  const config = JSON.parse(rawJson || "{}") as any;

  filterFonts(config);

  return config;
};
